import { isRouteErrorResponse, useRouteError } from 'react-router';

import InlineMessage from '@ingka/inline-message';
import crossCircleIcon from '@ingka/ssr-icon/paths/cross-circle';
import { translate } from '@repo/phrase';
import { Container } from '@repo/ui/container';

interface RouteErrorData {
    message: string;
}

const isErrorData = (data: unknown): data is RouteErrorData => {
    return typeof data === 'object' && data !== null && 'message' in data;
};

const getRouteMessageBody = (error: unknown): string => {
    if (!isRouteErrorResponse(error)) {
        return String(error);
    }
    const errorDataMessage = isErrorData(error.data) ? `-> ${error.data.message}` : '';
    return `${error.statusText} ${errorDataMessage}`;
};

export const RouterError = () => {
    const error = useRouteError();

    const routeMessage = {
        title: isRouteErrorResponse(error) ? `Error: ${error.status}` : translate('router_error_title'),
        body: getRouteMessageBody(error),
    };

    return (
        <Container testId="route-error" padding>
            <InlineMessage
                title={routeMessage.title}
                body={routeMessage.body}
                variant="negative"
                ssrIcon={crossCircleIcon}
            />
        </Container>
    );
};
